'use client';

import React, { useEffect, useState } from 'react';
import Heading from 'src/components/Heading/Heading';
import CardBlogPost from 'src/components/Card/CardBlogPost';
import CarouselGeneric from 'src/components/Carousel/CarouselGeneric';
import { SliceComponentProps } from '@prismicio/react';
import {
    Content,
    FilledContentRelationshipField,
    Query,
} from '@prismicio/client';
import { BlogPageDocument } from 'prismicio-types';

type BlogRelatedPostsProps = SliceComponentProps<Content.BlogRelatedPostsSlice>;

const BlogRelatedPosts = ({ slice }: BlogRelatedPostsProps) => {
    const [relatedPosts, setRelatedPosts] =
        useState<Query<BlogPageDocument<string>>>();

    useEffect(() => {
        const init = async (posts: string[]) => {
            const query = JSON.stringify({ query: posts });
            const requestOptions = {
                method: 'POST',
                body: query,
                headers: {
                    'Content-Type': 'application/json',
                    charset: 'utf-8',
                },
            };
            fetch('/prismic/api/get-blog-by-uids', requestOptions)
                .then((response) => response.json())
                .then((result) =>
                    setRelatedPosts(result as Query<BlogPageDocument<string>>),
                );
        };

        const posts = slice.items
            .map((item) => {
                const post = item.blog_post as FilledContentRelationshipField;
                if (post) {
                    return post.uid;
                }

                return null;
            })
            .filter((post) => post) as string[];
        posts.length === slice.items.length && init(posts);
    }, []);

    return relatedPosts?.results && relatedPosts.results.length ? (
        <section className="bg-sand-light py-8 last:mb-0 lg:mt-4 lg:rounded-xl last:lg:mb-4">
            <div className="mx-auto px-4 text-left md:text-center">
                <Heading level="h2" className="mb-4">
                    {slice.primary.title}
                </Heading>
            </div>
            <div className="mx-auto px-4">
                <CarouselGeneric>
                    {relatedPosts.results &&
                        relatedPosts.results.map((post, index) => {
                            return <CardBlogPost post={post} key={index} />;
                        })}
                </CarouselGeneric>
            </div>
        </section>
    ) : null;
};

export default BlogRelatedPosts;
